import { getEnvVar } from '@/utils/env';
import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { QUOTE_LOG_URL, ADMIN_URL } from './constant/BaseApiUrl';

const quoteLogUrl = getEnvVar('VITE_QUOTE_LOG_ACTIVE') == 'true' ? QUOTE_LOG_URL : ADMIN_URL;

export default class LogService {
  getLogXML(quoteId: string) {
    return axios.get(`${quoteLogUrl}logs/quotes?quoteId=${quoteId}`);
  }

  historyRuleLog(type: string, payload: any) {
    return axios.post(`${quoteLogUrl}logs/${ApiKey.FILTER}/${ApiKey.HISTORY_LOG}?type=${type}`, payload);
  }
}
